import(/* webpackMode: "eager" */ "/root/repo/src/app/settings/layout.tsx");
